const INFORMATIVES_ROUTES = {
  path: 'informatives',
  component: () =>
    import('@/pages/Informatives/InformativesPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'informatives.index',
      component: () => import('@/pages/Informatives/InformativesPage.vue'),
    },
    {
      path: 'create',
      name: 'informatives.create',
      component: () => import('@/pages/Informatives/InformativesFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'informatives.edit',
      component: () => import('@/pages/Informatives/InformativesFormPage.vue'),
    },
  ],
};

export default INFORMATIVES_ROUTES;
